export default "__VITE_ASSET__DD1gZLx7__"